import { mapValues } from 'lodash';
import { logger as baseLogger } from '@fiverr-private/obs';

const LOGGER_TAG = {
    delivered_by: 'dm_brief_creation',
};

/**
 * The costume logger is created by iterating over the initial logger object and wrapping its methods.
 * - If a method (e.g., `info`, `warn`, `error`) is found, it is replaced with a function that calls
 * the original method while appending the `LOGGER_TAG` object to the enrichment data of the log entry.
 * - Non-function properties of the logger remain unchanged.
 */
export const logger = mapValues(baseLogger, (value) => {
    if (typeof value === 'function') {
        return (entity, enrichment) => {
            value(entity, { ...enrichment, ...LOGGER_TAG });
        };
    }

    return value;
}) as typeof baseLogger;
